// extracted by mini-css-extract-plugin
module.exports = {"badgeContainer":"styles_badgeContainer__1CWSO","badgeIcon":"styles_badgeIcon__2EhxZ"};